<template>
  <div class="publication-tab-citations">
    <white-block>
      <content-container class="content-padding pt-40 pb-40">
        <bordered-block>
          <menu-publication :id="publication.id" :active="route.params?.tab" />
        </bordered-block>
      </content-container>

      <content-container class="content-padding pt-40 pb-40">
        <gray-block class="p-30 mb-40 round">@@@</gray-block>
        <gray-block class="p-30 mb-40 round">@@@</gray-block>
      </content-container>
    </white-block>
  </div>
</template>

<script setup>
import WhiteBlock from "@/components/blocks/WhiteBlock.vue";
import ContentContainer from "@/views/portal/components/ContentContainer.vue";
import BorderedBlock from "@/views/portal/components/BorderedBlock.vue";
import MenuPublication from "@/views/portal/components/menus/MenuPublication.vue";
// import {useApi} from "@/api/use-api";
import {useRoute} from "vue-router";
import {onMounted, watch} from "vue";
import GrayBlock from "@/components/blocks/GrayBlock.vue";

// const api = useApi();
const route = useRoute();
// const citations = ref([]);

const props = defineProps({
  publication: {
    type: Object,
    required: true,
  },
});

const getCitations = async () => {
  if (undefined === props.publication.uuid || !props.publication.uuid) return;
  try {
    // const response = await api.fingerprint.groups({
    //   page: 1,
    //   'per-page': 1000,
    //   sort: '-weighted_rank',
    //   content_family: 2,
    //   content_uuid: props.publication.uuid,
    // });
    //
    // response.fingerprints.map((fps) => {
    //   fps.label = fps.thesauriName;
    //   fps.items.map((fp) => {
    //     fp.tooltip = fp.weightedRank;
    //   });
    // });
    //
    // fingerprints.value = response.fingerprints;
  } catch (error) {
    console.error('error', error);
  }
};

onMounted(() => {
  getCitations();
});

watch(
    () => props.publication.id,
    () => {
      getCitations();
    }
);
</script>

<style lang="scss" scoped>

</style>